import React, { useState } from 'react';
import classes from "./summer.module.css";
import VideoSection from '../../containers/videoSection/videoSection';
import WelcomeSection from '../welcomeSection/welcomeSection';
import Activities from '../activities/activities';
import Staff from '../staff/staff';
import Sessions from '../sessions/sessions';
import Background from '../../../assets/images/summer-session.png';

const SummerCamp = (props) => {
    const [showCheckout, setShowCheckout] = useState(false);
    return (
        <div className={classes.Container}>
            {/* <VideoSection src="https://www.youtube.com/embed/YOUR_VIDEO_ID" /> */}
            <WelcomeSection title={parseInt(localStorage.getItem('language')) === 1 
                        ? "WELCOME TO 6 YARD SUMMER CAMP" 
                        : "نادي 6 يارد الصيفي"} camp='summer' info={props.summerCamp?.info} />
            <Activities title={parseInt(localStorage.getItem('language')) === 1 
                        ? "SUMMER ACTIVITIES" 
                        : "الأنشطة الصيفية"} activities={props.summerCamp?.activities} camp='summer' />
            <Staff title={parseInt(localStorage.getItem('language')) === 1 
                        ? "SUMMER STAFF" 
                        :  "طاقم الصيف"} staffData={props.summerCamp?.staff} camp='summer' />
            <Sessions title={parseInt(localStorage.getItem('language')) === 1 
                        ? "SESSIONS" 
                        :  "الجلسات"} offers={props.summerCamp?.packages} camp='summer'
                extraServices={props.summerCamp?.extra_services}
                setSelectedPlan={props.setSelectedPlan}
                setShowCampRegistrationForm={props.setShowCampRegistrationForm}
                isAuthenticated={props.isAuthenticated} setShowLoginForm={props.setShowLoginForm}
                description={props.summerCamp?.info?.session_text} background={Background}/>
        </div>
    )
}
export default SummerCamp;